import {
  FormControl,
  FormControlLabel,
  InputLabel,
  Paper,
  Radio,
  RadioGroup,
  withStyles,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { PieChart, Pie, Cell } from "recharts";
import { useField, useFormikContext } from "formik";

const COLORS = ["#0072BC", "#002856", "#7EDBFA", "#FF8042"];

const OPTIONS = {
  2: "Moderate (LC-50)",
  3: "Conservative (LC-25)",
  4: "Aggressive (LC-75)",
};
const LABELS = {
  E: "Equity",
  C: "Corp Bonds",
  G: "Govt Sec",
};

export const PieChartRadioGroup = ({
  lifecycleOptions = {},
  name,
  label,
  fullWidth,
  commonProps = {},
  ...rest
}) => {
  const [lifeCyclePercentages, setLifeCyclePercentages] = useState({});

  useEffect(() => {
    setLifeCyclePercentages(lifecycleOptions);
  }, [lifecycleOptions]);

  const [field, meta] = useField(name);
  const { value, ...other } = field;
  const formikContext = useFormikContext();
  const { isSubmitting: disabled } = formikContext;
  const errorMessage = meta.error && meta.touched ? meta.error : "";

  const keys = Object.keys(lifeCyclePercentages);

  return (
    <div className="d-flex flex-column">
      <div className="nps-form-label">{label}</div>
      <FormControl component="fieldset" style={{ marginLeft: "15px" }}>
        <RadioGroup
          aria-label="Search"
          name="search"
          value={value}
          style={{ flexDirection: "row" }}
          disabled={disabled}
          {...other}
          {...rest}
        >
          {keys.map((_lifeCycleOption) => {
            const percentageAllocations =
              lifeCyclePercentages[_lifeCycleOption];

            return (
              <Paper className="nps-pie-chart-container" key={_lifeCycleOption}>
                <div
                  key={_lifeCycleOption}
                  className={
                    "investor-radio-button input-margin d-flex flex-column"
                  }
                >
                  <div
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      borderBottom: "1px dotted #ccc",
                    }}
                  >
                    <FormControlLabel
                      label={OPTIONS[_lifeCycleOption]}
                      value={_lifeCycleOption}
                      control={
                        <Radio
                          className="investor-search-radio"
                          style={{ color: "#033f7c" }}
                        />
                      }
                    />
                  </div>
                  <div className="nps-pie-chart-container">
                    <PieChart width={150} height={150}>
                      <Pie
                        fill="#8884d8"
                        data={percentageAllocations}
                        dataKey="MaxValue"
                        nameKey="AssetCategory"
                        innerRadius={30}
                        outerRadius={40}
                      >
                        {percentageAllocations.map((entry, index) => (
                          <Cell
                            name={entry.AssetCategory}
                            key={`cell-${index}`}
                            fill={COLORS[index]}
                          />
                        ))}
                      </Pie>
                    </PieChart>
                    <div className="nps-pie-chart-map">
                      {percentageAllocations.map((entry, index) => (
                        <div className="d-flex " key={index}>
                          <div
                            style={{
                              backgroundColor: COLORS[index] || "red",
                              height: 10,
                              marginTop: 4,
                              width: 10,
                              padding: 5,
                            }}
                          />
                          <span>
                            {LABELS[entry.AssetCategory]} - {entry.MaxValue}%
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Paper>
            );
          })}
        </RadioGroup>
      </FormControl>
      <div className="nps-error-message">{errorMessage}</div>
    </div>
  );
};

const FormLabel = withStyles({
  root: {
    fontSize: "14px",
    fontFamily: "OpenSans-Regular",
    marginLeft: "20px",
    marginBottom: "20px",
    fontWeight: 400,
    color: "#000",
  },
})(InputLabel);
